var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
var NewsLayout = /** @class */ (function (_super) {
    __extends(NewsLayout, _super);
    function NewsLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewsLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, Component = _a.component, rest = __rest(_a, ["intl", "component"]);
        return (_jsx(Route, __assign({}, rest, { render: function (matchProps) { return (_jsxs("div", __assign({ className: 'content' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: intl.formatMessage({ id: 'news.title' }) }), _jsx("meta", { name: 'description', content: intl.formatMessage({ id: 'news.description' }) })] }), _jsxs("div", __assign({ className: 'blc_faq' }, { children: [_jsxs("div", __assign({ className: 'backward' }, { children: [_this.props.location.pathname !== '/news' && _jsx(Link, { to: '/news', className: 'ajax' }), _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: intl.formatMessage({ id: 'news.title' }) })) }))] })), _jsx(Component, __assign({}, matchProps))] }))] }))); } })));
    };
    return NewsLayout;
}(React.Component));
export default injectIntl(NewsLayout);



// WEBPACK FOOTER //
// ./src/components/info/news/NewsLayout.jsx